import transaction from './translation/transaction';

const enLocale = {
  translation: {
    transaction,
  },
};

export default enLocale;
